import * as React from 'react';

import { Button } from '@components/common';

interface SlideoutFooterProps {
  isLoading: boolean;
  onSave: () => void;
  onCancel: () => void;
}

export const ScreenerConfigSlideoutFooter: React.FC<SlideoutFooterProps> = ({ isLoading, onSave, onCancel }) => {
  return (
    <>
      <div className='space-x-2'>
        <Button loading={isLoading} disabled={isLoading} onClick={onSave} primary>
          Save
        </Button>
        <Button disabled={isLoading} onClick={onCancel}>
          Cancel
        </Button>
      </div>
    </>
  );
};
